<script>
    import { triage, triageDesc } from '../store.js'

    let header = false;
    let tos_url = "https://drive.google.com/open?id=16ctFTh6ggV9NkaMRc_idSWUXyIFyC5nZ";
    let pp_url = "https://drive.google.com/open?id=16bx1eM8n1Eyyb06Sd4JLRl_FywQxi1ol";

    let iframe_src = `https://covid19.infermedica.com/en/?header=${header}&tos_url=${tos_url}&pp_url=${pp_url}`;

    let frame_class = "main standard";
    let showBanner = false;
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.onmessage = function (e) {
        let res = JSON.parse(e.data);
        console.log(res);
        frame_class = "main call_doctor";
        showBanner = true;

        let triage_label = res.data.triage_label;
        let triage_desc = res.data.triage_description;

        triage.set(triage_label)
        triageDesc.set(triage_desc)
    }
</script>

<main>
    {#if showBanner === true}
    <div class="banner">
        <a class="btn btn-primary" href="/qr">Proceed to QR Code →</a>
    </div>
    {/if}
    <div class="iframe-container">
        <iframe title="assessor_frame" class={frame_class} src={iframe_src}></iframe>
    </div>
</main>

<style>
    .main {
        border: 0;
        max-height: 1024px;
        width: 100vw;
        max-width: 760px;
        position: absolute;
        background-image: url("../loader.gif");   
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }

    .standard {
        top: 42px;
        bottom: 0;
        left: 0;
        right: 0;
        height: calc((var(--vh, 1vh) * 100) - 42px);
    }

    .call_doctor {
        top: 100px;
        bottom: 0;
        left: 0;
        right: 0;
        height: calc((var(--vh, 1vh) * 100) - 100px);
    }

    .btn {
        position: absolute;
        top: 37px;
        width: 240px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
    }

    @media screen and (min-width:760px) {
        .main {
            bottom: 24px;
            left: 50%;
            margin-left: -380px;
            right: 0;
            width: 100vw;
            max-width: 760px;
            border-radius: 4px;
            box-shadow: rgba(50, 50, 93, 0.11) 0px 4px 6px 0px, rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
        }

        .standard {
            top: 74px;
            height: calc(100vh - 112px);
        }

        .btn {
            top: 46px;
            width: 420px;
        }

        .call_doctor {
            top: 120px;
            height: calc((var(--vh, 1vh) * 100) - 150px);
        }
    }
</style>